import React from "react"
import { Typography, Box, Grid } from "@mui/material"
import Stepper from "./Stepper"
import Error from "../AlertMessage/ErrorPage"
import { handleImageError } from "../../helpers/imageErrorHandler"

const classes: any = {
	paper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		minHeight: "calc(100vh - 40px)",
		boxSizing: "border-box",
	},
	headerText: {
		paddingTop: "20px",
		paddingBottom: "5px",
		marginBottom: "20px",
		borderBottom: `solid 2px`,
		borderColor: "secondary.main",
	},
}

export default function SignUp(props: any) {
	const alias: any = window.location.pathname.split("/")[1]
	const config: any = { businessAlias: alias, partnerApiKey: "mm" }
	React.useEffect(() => {
		props.getClubDetails(config)
	}, [])

	return (
		<Box sx={classes.paper} style={{ padding: "20px" }}>
			{!props.clubData && props.clubDataSuccess ? (
				<Error />
			) : (
				<Grid
					size={{ xs: 12, sm: 12, lg: 5 }}
					sx={classes.paper}
					style={{
						height: "90%",
						maxHeight: "100%",
						maxWidth: "600px",
					}}
				>
					{props.clubData?.logoPath ? (
						<img src={props.clubData?.logoPath} width={180} alt="logo" onError={handleImageError} />
					) : null}
					<Typography sx={classes.headerText} component="h3" variant="h5">
						SIGN UP
					</Typography>
					{props.clubData.canUserSelfRegister && (
						<Typography style={{ fontSize: 16 }} component="h6" variant="h5">
							SIGN UP IN 3 EASY STEPS
						</Typography>
					)}
					<Stepper {...props} />
				</Grid>
			)}
		</Box>
	)
}
